<template>
  <div class="fileListDetail">
    <div class='titleBar'>
      <div >files</div>
      <div>
        <md-icon class="icon  active" >view_list</md-icon >
        <md-icon class="icon  ">apps</md-icon >
      </div>
    </div>
    <div class='list'>
      <div class='items' >
        <div class='item title'></div>
        <div class='item title'>name</div>
        <div class='item title'>location</div>
        <div class='item title'>last modified</div>
        <div class='item title'>size</div>
      </div>
      <div class='items'>
        <div class='item center'><img src='../assets/ic-media.svg' /></div>
        <div class='item '>Ad-benefit-august.mp4</div>
        <div class='item '>my drive</div>
        <div class='item '>2019/8/20</div>
        <div class='item '>6 kb</div>
      </div>
      <div class='items'>
        <div class='item center'><img src='../assets/ic-ppt.svg' /></div>
        <div class='item '>Presentation-Q1.pdf</div>
        <div class='item '>my drive</div>
        <div class='item '>2019/8/20</div>
        <div class='item '>18 kb</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileListDetail',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fileListDetail{
  padding: 24px 85px 24px 85px;
  background: #F8F8F8;
  height: 100%;
}
.titleBar{
  display: flex;
  justify-content: space-between;


}
.titleBar > div{
  text-transform: uppercase;
  text-align: center;
  align-self: center;
  font-size: 24px;
  font-style: "Helvetica Neue" bold;
  line-height: 24px;
}

 .icon{
   margin: 5px;
   color:#AAA;
 }

  .icon.active{
   color:#000;
 }

 .items{
   padding-top: 20px;
   display: grid;
   grid-template-columns: 1fr 5fr 2fr 2fr 1fr;
   height: 70px;
   margin: 0 10px 10px;
   border-bottom: 1px solid rgba(0, 0, 0, 0.16);
 }

 .item.title{
   font-style: 'Open Sans';
   font-size: 16px;
   text-align: left;
  
 }

 .item.title{
   text-transform: uppercase;
 }

 .item.center{
  text-align: center;
  /* padding-right:10px; */
 }



 .item:after{
    

 }

 /* .item{
  width:240px;
  height: 72px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px #00000029;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  padding:8px;
  margin:8px;
  cursor: pointer;
 } */

 



 .file_text{
   font-size:16px;
   font-style: 'Open Sans';
   
 }
</style>
